function LeftArrowIcon({ size, stroke }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" stroke-width={stroke} height={size} fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
    );
}

export default LeftArrowIcon;